import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/core';

const KEYBOARD_CLASS = 'using-keyboard';
const MOUSE_CLASS = 'using-mouse';

/**
 * Detecta si el usuario navega con teclado o ratón y lo refleja
 * en clases del body, para poder limitar el anillo :focus-visible
 * a la navegación por teclado (especialmente en inputs de texto).
 */
@Injectable({ providedIn: 'root' })
export class FocusModalityService {
  private started = false;

  private readonly onKeyDown = (event: KeyboardEvent) => {
    if (event.metaKey || event.altKey || event.ctrlKey) {
      return;
    }

    const navigationKeys = [
      'Tab',
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Enter',
      ' ',
      'Escape',
    ];
    if (navigationKeys.includes(event.key)) {
      this.setKeyboard();
    }
  };

  private readonly onPointerDown = () => {
    this.setMouse();
  };

  constructor(@Inject(DOCUMENT) private document: Document) {}

  init(): void {
    if (this.started) {
      return;
    }

    this.started = true;
    this.document.body.classList.add(MOUSE_CLASS);
    this.document.addEventListener('keydown', this.onKeyDown, true);
    this.document.addEventListener('mousedown', this.onPointerDown, true);
    this.document.addEventListener('pointerdown', this.onPointerDown, true);
  }

  destroy(): void {
    if (!this.started) {
      return;
    }

    this.started = false;
    this.document.removeEventListener('keydown', this.onKeyDown, true);
    this.document.removeEventListener('mousedown', this.onPointerDown, true);
    this.document.removeEventListener('pointerdown', this.onPointerDown, true);
    this.document.body.classList.remove(KEYBOARD_CLASS, MOUSE_CLASS);
  }

  private setKeyboard(): void {
    this.document.body.classList.add(KEYBOARD_CLASS);
    this.document.body.classList.remove(MOUSE_CLASS);
  }

  private setMouse(): void {
    this.document.body.classList.add(MOUSE_CLASS);
    this.document.body.classList.remove(KEYBOARD_CLASS);
  }
}
